"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _popmotion = require("popmotion");
var _types = require("./types");
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../hooks/useIsomorphicLayoutEffect"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Sheet = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a;
  var children = props.children,
    parentRef = props.parentRef,
    _b = props.duration,
    duration = _b === void 0 ? 300 : _b,
    _c = props.direction,
    direction = _c === void 0 ? 'bottom' : _c,
    _d = props.openOnMount,
    openOnMount = _d === void 0 ? true : _d,
    _e = props.forceRender,
    forceRender = _e === void 0 ? false : _e,
    DOMProps = __rest(props, ["children", "parentRef", "duration", "direction", "openOnMount", "forceRender"]);
  var wrapperRef = (0, _react.useRef)(null);
  var _f = (0, _react.useState)(forceRender),
    displayContent = _f[0],
    setDisplayContent = _f[1];
  var _g = (0, _react.useState)({
      width: undefined,
      height: undefined
    }),
    sheetRect = _g[0],
    setSheetRect = _g[1];
  (0, _useIsomorphicLayoutEffect.default)(function () {
    var calculateSheetRect = function calculateSheetRect() {
      var _a, _b;
      var rect;
      if (parentRef && parentRef.current) {
        rect = {
          width: (0, _popmotion.toDecimal)(parentRef.current.offsetWidth),
          height: (0, _popmotion.toDecimal)(parentRef.current.offsetHeight)
        };
      } else if (wrapperRef.current) {
        rect = {
          // @ts-ignore
          width: (0, _popmotion.toDecimal)((_a = wrapperRef.current.parentNode) === null || _a === void 0 ? void 0 : _a['offsetWidth']),
          // @ts-ignore
          height: (0, _popmotion.toDecimal)((_b = wrapperRef.current.parentNode) === null || _b === void 0 ? void 0 : _b['offsetHeight'])
        };
      }
      if (rect) {
        setSheetRect(rect);
      }
    };
    calculateSheetRect();
  }, [parentRef]);
  var animationParams = (0, _react.useMemo)(function () {
    var dimensionValue = null;
    switch (direction) {
      case _types.SheetDirections.Left:
      case _types.SheetDirections.Right:
        dimensionValue = sheetRect.width || null;
        break;
      default:
      case _types.SheetDirections.Top:
      case _types.SheetDirections.Bottom:
        dimensionValue = sheetRect.height || null;
        break;
    }
    var params = {
      key: direction,
      value: dimensionValue
    };
    return params;
  }, [direction, sheetRect.height, sheetRect.width]);
  var updateSheet = (0, _react.useCallback)(function (key, value) {
    if (wrapperRef.current && typeof value === 'number') {
      wrapperRef.current.style[key] = "".concat((0, _popmotion.toDecimal)(value), "px");
    }
  }, []);
  var openSheet = (0, _react.useCallback)(function () {
    setDisplayContent(true);
    (0, _popmotion.animate)({
      from: animationParams.value,
      to: 0,
      duration: duration,
      onPlay: function onPlay() {
        if (wrapperRef.current) {
          wrapperRef.current.style.opacity = '1';
        }
      },
      onUpdate: function onUpdate(latest) {
        updateSheet(animationParams.key, latest);
      }
    });
  }, [duration, animationParams, updateSheet]);
  var closeSheet = (0, _react.useCallback)(function () {
    (0, _popmotion.animate)({
      from: 0,
      to: animationParams.value,
      duration: duration,
      onUpdate: function onUpdate(latest) {
        updateSheet(animationParams.key, latest);
      },
      onStop: function onStop() {
        if (!forceRender) {
          setDisplayContent(false);
        }
        if (wrapperRef.current) {
          wrapperRef.current.style.opacity = '0';
        }
      }
    });
  }, [duration, animationParams, updateSheet, forceRender]);
  (0, _react.useEffect)(function () {
    if (openOnMount) {
      openSheet();
    }
  }, [openOnMount, openSheet]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      open: openSheet,
      close: closeSheet
    };
  }, [closeSheet, openSheet]);
  return (0, _jsxRuntime.jsx)(Styled.Wrapper
  // @ts-ignore
  , __assign({
    // @ts-ignore
    ref: wrapperRef
  }, DOMProps, {
    style: __assign(__assign({}, DOMProps === null || DOMProps === void 0 ? void 0 : DOMProps.style), (_a = {
      width: sheetRect.width,
      height: sheetRect.height,
      opacity: 0
    }, _a[animationParams.key] = animationParams.value, _a))
  }, {
    children: displayContent && children
  }));
});
Sheet.displayName = 'Sheet';
var _default = Sheet;
exports.default = _default;